import script from "./OrderPointOfSale.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPointOfSale.vue?vue&type=script&setup=true&lang=js"

import "./OrderPointOfSale.vue?vue&type=style&index=0&id=5bb2fe4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb2fe4c"]])

export default __exports__